import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [showSearchBox, setShowSearchBox] = useState(false);
  const navigate = useNavigate();

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim().length > 0) {
      navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
      setSearchQuery('');
      setShowSearchBox(false);
    }
  };

  const handleSearchIconClick = () => {
    setShowSearchBox(!showSearchBox);
    if (!showSearchBox) {
      setTimeout(() => {
        const searchInput = document.querySelector('.header-search-input');
        if (searchInput) {
          searchInput.focus();
        }
      }, 100);
    }
  };

  return (
    <div className="top-header">
      <div className="top-header-content">
        <div className="top-header-left">
          <span className="header-icon">✉</span>
          <span>support@nqcagency.com</span>
          <span className="header-separator">|</span>
          <span className="header-icon">📍</span>
          <span>New York, NY 10005</span>
        </div>
        <div className="top-header-right">
          {showSearchBox ? (
            <form className="header-search-form" onSubmit={handleSearchSubmit}>
              <input
                type="text"
                className="header-search-input"
                placeholder="Search..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onBlur={() => {
                  setTimeout(() => {
                    if (searchQuery.trim().length === 0) {
                      setShowSearchBox(false);
                    }
                  }, 200);
                }}
              />
              <button type="submit" className="header-search-submit">
                <span className="search-icon">🔍</span>
              </button>
              <button
                type="button"
                className="header-search-close"
                onClick={() => {
                  setShowSearchBox(false);
                  setSearchQuery('');
                }}
              >
                ✕
              </button>
            </form>
          ) : (
            <span className="search-icon" onClick={handleSearchIconClick} style={{ cursor: 'pointer' }}>
              🔍
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;

